import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Typography, AppBar, Toolbar, Divider, IconButton, MenuItem, Menu, Icon, Tooltip } from '@material-ui/core';
import HyperbloxLogo from '../../images/hyperblox-logo.png';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MenuIcon from '@material-ui/icons/Menu';
import Drawer from '@material-ui/core/Drawer';
import CloseIcon from '@material-ui/icons/Close';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { useHistory, withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getBuildLoader, getSavingInProgress, getRightDrawerStatus, getDeployLoader, getCodeEditStatus, getInnerScreenRender, getReRender, getBlueprintDetails, getBottomDrawerStatus, getElementOnFocus, getAiAssistantLoading, getAiAssistant, getOpenDeployment, getLogRedirectionData } from '../../store/global/selectors';
import { handleSnackBar, setFocusElement, toggleRightDrawer, setTabOnFocus, setBuildLoader, setDeployLoader, setIsDocumentClicked, handleBottomTerminal, handleLogs, closeBottomTerminal, triggerTour, toggleBottomDrawer, setTriggerBlueprintValidation, openAiPromptModal, updateAiAssistant, closeAiAssistantModal, toggleSimulationRun, toggleDeployment } from "../../store/global/actions";
import { resetBluePrint, audit } from "../../store/blueprint/actions";
import DeploySelector from "../../components/molecules/blueprint/deploy/DeploySelector";
import CreateTemplateDialog from '../../components/molecules/clusterlet_templates/CreateTemplateDialog';
import CustomizedDialogs from "../../components/atoms/dialog";
import { RenameBlueprintForm } from '../../components/molecules/blueprint/RenameBlueprint';
import RestoreBlueprintAlert from '../../components/molecules/alerts/RestoreBlueprintAlert';
import { setDrawEvent, setDrawNestedTransaction, setDrawReuseTransaction, setDisablePan, setMenuAction, setReRender } from '../../store/global/actions';
import { filterBlueprints, getDetailsFromUrl } from "../../services/blueprint";
import { CloneTransaction } from "../../components/molecules/transactions/CloneTransaction";
import { clearAll } from "../../store/blueprint/actions";
import ErrorPresenter from '../../components/atoms/errors/ErrorPresenter';
import { invokePostService, invokeGetService, invokeV1GetService, invokePostV1Service, setInnerScreenRender } from "../../store/global/actions";
import DeleteTransactionAlert from '../../components/molecules/alerts/DeleteTransactionAlert'
import DeleteSimulationAlert from '../../components/molecules/alerts/DeleteSimulationAlert';
import RunSimulationDialog from '../../components/molecules/alerts/RunSimulationAlert';
import SimulationLogsAlert from '../../components/molecules/alerts/SimulationLogsAlert';
import BlueprintValidator from '../../components/atoms/dialog/BlueprintValidator';
import ExportBlueprintFilesAlert from '../../components/molecules/alerts/ExportBlueprintFileAlert';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
import ClusterletViewSelectorForDashboard from '../../components/molecules/dashboardBuilder/ClusterletViewSelectorForDashboard';
import BuildAlert from '../../components/molecules/alerts/BuildAlert';
import UndoRedo from '../../components/molecules/UndoRedo/index';
import Select, { StylesConfig } from 'react-select';
import BlueprintSelect from '../../components/molecules/blueprintSearchButton/BlueprintSearchButton';
import EditableTitle from '../../components/atoms/inputElemets/EditableTitle';
import { StarsIcon } from '../../components/molecules/icons';
import { logDebug, logError, logInfo, logWarn } from '../../utils/logger';
import BlueprintValidationsList from '../../components/molecules/blueprintValidator/blueprintValidationsList';
import AIAssistanceModal from '../../components/molecules/AIAssistance/AIAssistanceModal';
import AlertDialog from '../../components/atoms/alertDialog/AlertDialog';
import OwnershipStatusLabel from '../../components/atoms/labels/OwnershipStatusLabel';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';

const menuDrawerWidth = "250px";
const useStyles = makeStyles((theme) => ({
  root: {
    // flexGrow: 1,
  },
  title: {
    flexGrow: 1,
    fontSize: '15px',
    color: "#2c3b4a"
  },
  AppBar: {
    zIndex: theme.zIndex.drawer + 2,
    backgroundColor: "#fff",
    backgroundSize: "cover",
    color: "#2c3b4a",
    fontFamily: "Roboto, Helvetica",
    fontWeight: 600,
    fontSize: "14px",
    // height: "60px",
    // marginTop: "-4px"
  },
  buildBtn: {
    textTransform: "none",
    margin: "0px 5px",
    color: "#2c3b4a",
    border: "solid 1px #2c3b4a",
    width: "60px",
    height: "32px",
    flexGrow: 0,
    padding: "6px 12px 7px 13px",
    borderRadius: "4px"
  },
  actionsBtn: {
    textTransform: "none",
    margin: "0px 5px",
    color: "#2c3b4a",
    border: "solid 1px #2c3b4a",
    width: "93px",
    height: "32px",
    flexGrow: 0,
    padding: "4px 5px 4px 11px",
    borderRadius: "4px"
  },
  openNewTab: {
    textTransform: "none",
    margin: "0px 5px",
    color: "#1677ff",
    backgroundColor: "#ffffff",
    border: "1px solid #1677ff",
    width: "auto",
    height: "32px",
    flexGrow: 0,
    padding: "3px 7px 3px 9px",
    borderRadius: "3px",
    lineHeight: "20px",
    boxShadow: "none",
    cursor: "pointer",
  
    "&:hover": {
      backgroundColor: "#f0f7ff",
      borderColor: "#1677ff",
      color: "#1677ff",
      boxShadow: "none"
    }
  },
  saveBtn: {
    textTransform: "none",
    margin: "0px 5px",
    color: "#2c3b4a",
    border: "solid 1px #2c3b4a",
    width: "73px",
    height: "32px",
    flexGrow: 0,
    padding: "4px 5px 4px 9px",
    borderRadius: "4px"
  },
  buildMenuBtn: {
    textTransform: "none",
    margin: "0px 5px",
    color: "#2c3b4a",
    border: "solid 1px #2c3b4a",
    width: "93px",
    height: "32px",
    flexGrow: 0,
    padding: "4px 5px 4px 11px",
    borderRadius: "4px"
  },
  deployBtn: {
    textTransform: "none",
    margin: "0px 5px",
    backgroundColor: '#2c3b4a',
    color: '#fff',
    width: "74px",
    height: "32px",
    flexGrow: 0,
    padding: "6px 13px 7px",
    borderRadius: "4px"
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    // justifyContent: 'space-between',
  },
  logo: {
    width: 34,
    marginRight: 17,
    marginLeft: -7
  },
  dividerContainer: {
    margin: '0px 10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  divider: {
    height: "32px",
    width: "1px",
    backgroundColor: "#2c3b4a"
  },
  blueprints: {
    flexGrow: 1,
    fontFamily: "Roboto, Helvetica",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#2c3b4a",
    marginLeft: "9px"
  },
  blueprintList: {
    textTransform: "none",
    margin: "0px 5px",
    color: "#2c3b4a",
  },
  undoRedoDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1
  },
  undoRedo: {
    textTransform: "none",
    margin: "0px 5px",
    color: "#2c3b4a",
    margin: 0
  },
  menuDrawer: {
    width: menuDrawerWidth,
    flexShrink: 0,
  },
  menuDrawerPaper: {
    width: menuDrawerWidth,
    backgroundColor: '#fff',
    zIndex: 1201
  },
  dropdownMenu: {
    marginTop: "34px",
  },
  dropdownMenuPaper: {
    borderRadius: "4px",
    border: "solid 1px #2c3b4a",
  },
  dropdownMenuList: {
    paddingTop: 0,
  },
  dropdownMenuListWithPadding: {
    paddingTop: 8,
  },
  menuItem: {
    '&:hover': {
      backgroundColor: "#DCDCDC",
    },
    fontWeight: "Normal"
  },
  menuDrawerList: {
    color: "#2c3b4a"
  },
  listItem: {
    padding: "0px 16px",
    textAlign: "right",
  },
  actionsHeading: {
    backgroundColor: "#3f4e5c",
    color: "#fff"
  },
  backdrop: {
    zIndex: 2000,
    color: "#fff",
  },
  readOnlyAlert: {
    display: "flex",
    flexGrow: 1,
    justifyContent: "right",
    marginRight: 10
  },
  blueprintsDiv: {
    display: "flex",
    cursor: "pointer"
  },
  entityName: {
    flexGrow: 1,
    fontFamily: "Roboto, Helvetica",
    fontSize: "16px",
    fontWeight: "bold",
    color: "#2c3b4a",
    marginLeft: "9px"
  },
  promptBtn: {
    background: "rgb(72, 86, 106)",
    borderRadius: '50%',
    border: 'none',
    boxShadow: "none",
    aspectRatio: '1/1',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    width: '2rem',
    // '&:hover':{
    //   background: "rgb(72, 86, 106)"
    // },
    '&:hover:not(:disabled)': {
      background: "rgb(72, 86, 106)"
    }
  },
  disableAgent: {
    background: "rgb(170 171 173)",
    cursor: "not-allowed"
  },
  titleRow: {
    display:    'flex',
    alignItems: 'center',
    '& > *': {
      marginBottom: '0 !important',
    },
  },
}));

function BlueprintTopBar(props) {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const history = useHistory();
  const normalScreen = useMediaQuery('(min-width:1048px)');
  const mediumScreen = useMediaQuery('(min-width:768px)');
  const currentUrl = window.location.href;
  const [slug, blueprintID, tag] = currentUrl.split('/').slice(4);
  const { entityId } = getDetailsFromUrl();
  const bottomDrawerStatus = useSelector(getBottomDrawerStatus);
  const elementOnFocus = useSelector(getElementOnFocus);
  const isAIAssistantActive = useSelector(getAiAssistantLoading);
  const {screen: currentScreen, entit} = getDetailsFromUrl()
  const openDeployment = useSelector(getOpenDeployment)

  const [screen, setScreen] = useState(null);
  const [openSave, setOpenSave] = useState(null);
  const [openBuildMenu, setOpenBuildMenu] = useState(null);
  const [anchorEl, setActionsAnchorEl] = useState(null);
  const [rightMenuOpen, setRightMenuOpen] = useState(false);
  const [blueprintsAnchorEl, setBlueprintsAnchorEl] = useState(null);
  const [openBackupRestore, setOpenBackupRestore] = useState(false);
  const [openRenameBlueprint, setOpenRenameBlueprint] = useState(false);
  const [deploySelectorPopUp, setDeploySelectorPopUp] = useState(false);
  const [openClusterletConfig, setOpenClusterletConfig] = useState(false);
  const [openCloneTransaction, setOpenCloneTransaction] = useState(false);
  const [openDeleteTransaction, setOpenDeleteTransaction] = useState(false);
  const [openDeleteSimulation, setOpenDeleteSimulation] = useState(false);
  const [selectedBlueprint, setSelectedBlueprint] = useState(undefined);
  const [isBlueprintSwitching, setIsBlueprintSwitching] = useState(false);
  const [validationError, setValidationError] = useState([]);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [selectedSimulation, setSelectedSimulation] = useState(null);
  const [myBlueprints, setMyBlueprints] = useState([]);
  const [sharedBlueprints, setSharedBlueprints] = useState([]);
  const [openBuildFiles, setOpenBuildFiles] = useState(false);
  // const [openSimulationLogs, setOpenSimulationLogs] = useState(false);
  const [openBuildLogs, setOpenBuildLogs] = useState(false);
  const [openDeployLogs, setOpenDeployLogs] = useState(false);
  const [openRunSimulationDialog, setOpenRunSimulationDialog] = useState(false)
  const [blueprintValidatorOpen, setBlueprintValidatorOpen] = useState(false)
  const [openExportBlueprintAlert, setOpenExportBlueprintAlert] = useState(false)
  const [deployConfig, setDeployConfig] = useState(null);
  const [showTour, setTour] = useState(false)
  const [allBlueprints, setAllBlueprints] = useState([]);
  const aiAssistantLoading = useSelector(getAiAssistantLoading)

  const [showValidationErrorsList, setShowValidationErrorsList] = useState(false);
  const [selectedView, setSelectedView] = useState(null)
  const [validationsList, setValidationsList] = useState([]);
  const [validationLoading, setValidationsLoading] = useState(false);
  const [deploymentData, setDeploymentData] = useState(null);

  const [showExitAlert, setShowExitAlert] = useState(false);
  const logRedirectionData = useSelector(getLogRedirectionData)

  const buildLoading = useSelector(getBuildLoader);
  const savingInProgress = useSelector(getSavingInProgress);
  const rightDrawerStatus = useSelector(getRightDrawerStatus);
  const codeEditStatus = useSelector(getCodeEditStatus);
  const innerScreenRender = useSelector(getInnerScreenRender);
  
  const reRender = useSelector(getReRender);
  const { requestContext } = useSelector(getAiAssistant);


  const entityTooltipMap = {
    view: "Views generation in progress",
    transaction: "Transactions generation in progress",
    simulation: "Testsuites generation in progress",
    database_profile: "Database profile generation in progress",
    system_model: "System model generation in progress",
    handler: "Handler generation in progress"
  };
  
  const tooltipTitle = requestContext?.entity ? entityTooltipMap[requestContext.entity] || "Hyperblox Agent" : "Hyperblox Agent";

  useEffect(() => {
    setScreen(findScreen());
    if (tag === 'transaction' && entityId !== undefined) {
      dispatch(invokeGetService('getTransactionAssociates', [entityId]))
        .then((response) => {
          if (response?.data?.transaction !== undefined) {
            setSelectedTransaction(response.data.transaction);
          }
        })
    }
    if (tag === 'testsuite' && entityId !== undefined) {
      dispatch(invokeGetService('getSimulationTestsuite', [entityId]))
        .then((response) => {
          if (response?.data?.testsuite !== undefined) {
            setSelectedSimulation(response.data.testsuite);
          }
        })
    }

    if (tag === 'view' && entityId !== undefined) {
      dispatch(invokeGetService('getView', [entityId]))
        .then((response) => {
          console.log({response})
          if (response?.view !== undefined) {
            setSelectedView(response.view);
          }
        })
    }
  }, [tag, entityId, innerScreenRender, reRender])

  useEffect(() => {
    if(openDeployment){
      dispatch(toggleDeployment(false));
      deployBlueprint(deploymentData)
    }
  },[openDeployment])

  useEffect(() => {
    dispatch(invokeGetService('getBlueprintList')).then((response) => {
      if (response?.status == true && response?.data) {
        const organizedBlueprints = [
          ...(response?.data.myBlueprints || []),
          ...(response?.data.sharedBlueprints)
        ].sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));

        const seletedBlueprintData = organizedBlueprints.find(bp => bp._id == blueprintID);
        
        setAllBlueprints(organizedBlueprints)
        setSelectedBlueprint(seletedBlueprintData);
      }
    });
    
  }, []);


  

  const findScreen = () => {

    let url = window.location.href;

    if (url.includes('system-model')) {
      return 'sm';
      // } else if (url.includes('information_flow')) {
    } else if (url.includes('transaction')) {

      return 'df';
    } else if (url.includes('views')) {
      return 'views';
    } else if (url.includes('assets')) {
      return 'assets';
    } else if (url.includes('teams')) {
      return 'teams';
    } else if (url.includes('testsuite')) {
      return 'testsuite';
    } else {
      return 'tv';
    }

  }




  const handleActionsClick = (e) => {
    setActionsAnchorEl(e.currentTarget);
  }

  const handleSaveClick = (e) => {
    setOpenSave(e.currentTarget);
  }

  const handleBuildMenuClick = (e) => {
    if (codeEditStatus) {
      dispatch(setIsDocumentClicked());
      return;
    }

    setOpenBuildMenu(e.currentTarget);
  }

  const handleBlueprintClick = (e) => {
    setBlueprintsAnchorEl(e.currentTarget);
  }

  const toggleMenuRightdrawer = (open) => {
    setRightMenuOpen(open);
  }

  const setClusterletType = (type) => {
    dispatch(setMenuAction(type));
  }

  const panReset = () => {
    const resetelement = document.getElementById('resetPanBtn');
    resetelement.click();
  }

  const panDisable = () => {
    panReset();
    dispatch(setDisablePan(true));
  }


  const transactionActions = (type) => {
    if (type === 'event') {
      dispatch(setDrawEvent(true));
      dispatch(handleSnackBar({ open: true, message: 'Start drawing event between clusterlets', severity: 'info' }));
    } else if (type === 'transaction') {

      dispatch(setFocusElement({ id: null, type: 'transaction' }));
      if (rightDrawerStatus === false) {
        dispatch(toggleRightDrawer());
      }

    } else if (type === 'nestedTransaction') {
      dispatch(setDrawNestedTransaction(true));
      dispatch(handleSnackBar({ open: true, message: 'Start drawing child transaction between clusterlets', severity: 'info' }));
    } else if (type === 'reusedTransaction') {
      dispatch(setDrawReuseTransaction(true));
      dispatch(handleSnackBar({ open: true, message: 'Start drawing transaction to reuse between clusterlets', severity: 'info' }));
    }
  }

  const onSelectBlueprint = async (event, value) => {

    try {
      if (codeEditStatus) {
        dispatch(setIsDocumentClicked());
        return;
      }
      if(bottomDrawerStatus)  dispatch(toggleBottomDrawer());
      handleBlueprintListClose();
      setIsBlueprintSwitching(true);
      dispatch(handleLogs([]));
      dispatch(handleBottomTerminal(false, ""))
      dispatch(setDeployLoader({ status: false }));
      dispatch(closeAiAssistantModal());
      dispatch(setFocusElement({}));
      dispatch(clearAll()).then(async res => {
        const newUrl = `/blueprint/${value.slug}/${value.value}/system-model`;
        props.history.push(newUrl);
        dispatch(setTriggerBlueprintValidation());
        setIsBlueprintSwitching(false);
        if (rightDrawerStatus === true) {
          dispatch(toggleRightDrawer());
        }
        setSelectedBlueprint(allBlueprints.find(item => item._id == value.value));
        dispatch(setReRender());
        dispatch(invokePostService('removeLocks', {}, []));
      });

    } catch (error) {
      logError({message: error})
    }
  }


  

  const onBuildBlueprint = async () => {
    
    setOpenBuildMenu(false)
    dispatch(invokeV1GetService('blueprintBuild', [])).then(res => {
      //dispatch(handleSnackBar({ open: true, message: 'Build initiated', severity: "info" }));
      setOpenBuildLogs(true)
      dispatch(setTabOnFocus(0))
    })

  }

  const openBuildHistory = () => {
    setOpenBuildMenu(false)
    setOpenBuildLogs(true)
    dispatch(setTabOnFocus(0))
  }

  const openDeploymentHistory = () => {
    setOpenDeployLogs(true)
    setOpenBuildMenu(false)
    dispatch(setTabOnFocus(0))
  }


  /** When deploying the blueprint */
  const onDeployBlueprint = async () => {
    setOpenBuildMenu(null);
    toggleMenuRightdrawer(false);
    dispatch(setDeployLoader({ status: true }));
    dispatch(closeBottomTerminal(false))
    dispatch(setTabOnFocus(0))
    // setDeploySelectorPopUp(true);
    let auditRespone = await dispatch(audit());

    if (auditRespone?.validationErrors && auditRespone?.validationErrors.length > 0) {
      setValidationError(auditRespone?.validationErrors);
    }
    else {
      setDeploySelectorPopUp(true);
    }
  }


  const deployBlueprint = (data) => {
    if (data === undefined && deployConfig == null) {
      dispatch(handleSnackBar({ open: true, message: 'Could not deploy.', severity: "error" }));
      return
    }

    if (data === undefined) {
      data = deployConfig
    }

    dispatch(invokePostV1Service('blueprintDeploy', data)).then(res => {
      //dispatch(handleSnackBar({ open: true, message: 'Deployment initiated', severity: "info" }));
      setOpenDeployLogs(true)
      setDeploySelectorPopUp(false)
    })

  }




  const onBackupRestore = () => {
    if (codeEditStatus) {
        dispatch(setIsDocumentClicked());
        console.log("Code edit status is true")
        return;
    }

    handleSaveClose();
    toggleMenuRightdrawer(false);
    setOpenBackupRestore(true)
  }

  const onViewBuildFiles = () => {
    setOpenBuildMenu(null);
    handleActionClose();
    setOpenBuildFiles(true);
    dispatch(setTabOnFocus(1))
  }

  const onViewSimulationLogs = (isNotRunning) => {
    setOpenBuildMenu(null);
    handleActionClose();
    if(isNotRunning){
      dispatch(toggleSimulationRun('view'))
    }else{
      dispatch(toggleSimulationRun('live'))
    }
  }

  const onExportBlueprint = () => {
    handleActionClose();
    setOpenBuildMenu(null);
    setOpenExportBlueprintAlert(true);

    // dispatch(invokeFileDownloadService('exportBlueprintfiles', {}))
    //   .then(response => {
    //     if (!response.ok) {
    //       throw new Error('Network response was not ok');
    //     }
    //     return response.blob()
    //   })
    //   .then(blob => {
    //     // Create a URL for the downloaded file
    //     const url = URL.createObjectURL(blob);

    //     // Trigger a download prompt
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.download = `abc.zip`;
    //     document.body.appendChild(link);
    //     link.click();
    //     document.body.removeChild(link);
    //     return { message: "Blueprint exported" }
    //   })
    //   .catch(error => {
    //     console.error('Error fetching zip file', error);
    //     // dispatch(handleSnackBar({ open: true, message: 'Blueprint export failed', severity: "error" }));
    //     return { message: "Blueprint export failed" }
    //   });

  }


  const onEventTYpes = () => {
    if (codeEditStatus) {
        dispatch(setIsDocumentClicked());
        console.log("Code edit status is true")
        return;
    }

    handleActionClose();
    toggleMenuRightdrawer(false);
    dispatch(setFocusElement({ id: null, type: 'event_types', screen: tag }));
    if (rightDrawerStatus === false) {
      dispatch(toggleRightDrawer());
    }
  }

  const onImportMessages = () => {
    if (codeEditStatus) {
        dispatch(setIsDocumentClicked());
        console.log("Code edit status is true")
        return;
    }

    handleActionClose();
    toggleMenuRightdrawer(false);
    dispatch(setTabOnFocus(1))
    dispatch(setFocusElement({ id: null, type: 'import_messages', screen: tag }));
    if (rightDrawerStatus == false) {
      dispatch(toggleRightDrawer());
    }
  }


  /** When clicking run simulation on topbar */
  const onRunSimulation = () => {
    setOpenBuildMenu(null)
    handleActionClose()
    setOpenRunSimulationDialog(true)
  }

  const onSelectClusterletDashboard = () => {
    if (codeEditStatus) {
        dispatch(setIsDocumentClicked());
        console.log("Code edit status is true")
        return;
    }


    handleActionClose();
    toggleMenuRightdrawer(false);
    setOpenClusterletConfig(true);
  }


  const handleActions = (setData) => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    setData(true)
  }


  const onCreateClusterlet = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    setClusterletType("analytics");
  }

  const onCreateInferEngine = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    setClusterletType("infer_engine");
  }

  const onCreateLearnEngine = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    setClusterletType("learn_engine");
  }

  const onCreateGenerateEngine = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    setClusterletType("generate_engine");
  }

  const onCreateDelegate = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    setClusterletType("external_function");
  }

  const onCreateDigitalTwin = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    setClusterletType("clusterlet");
  }



  const onCreateEnterpriseApp = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    setClusterletType("user");
  }

  const onAddEvent = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    transactionActions('event');
    panDisable();
  }

  const onImportTransaction = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    transactionActions('reusedTransaction');
    panDisable();
  }

  const onChildTransaction = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    transactionActions('nestedTransaction');
    panDisable();
  }

  const onEditTransaction = async () => {
    if (codeEditStatus) {
        dispatch(setIsDocumentClicked());
        console.log("Code edit status is true")
        return;
    }

    handleActionClose();
    toggleMenuRightdrawer(false);
    
    dispatch(invokeGetService('getTransactionAssociates', [entityId]))
      .then((response) => {
        if (response?.data?.transaction !== undefined) {

          // To rener the transction details in the bottom drawer
          if(elementOnFocus?.id !== entityId){
            console.log("----setting element on focus----")
            dispatch(setFocusElement({
              transaction: selectedTransaction._id, 
              id: selectedTransaction._id, 
              type: "transaction", 
              name: response?.data?.transaction?.name,
              item: response?.data?.transaction
            }));
            dispatch(setTabOnFocus(0));
          }
         
        }else if (response?.status === false && response?.code === 255 && response.transactionNotFound === true) {
          dispatch(setFocusElement(null));
          dispatch(setInnerScreenRender())
          history.push(`/blueprint/${slug}/${blueprintID}/system-model`);
        }
      })
    // dispatch(setFocusElement({ id: selectedTransaction._id, type: 'transaction', name: selectedTransaction?.name }));

  }

  const onEditSimulation = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    dispatch(setFocusElement({ type: 'simulation', action: "edit", id: selectedSimulation._id, name: selectedSimulation.name, description: selectedSimulation.description }));
    if (rightDrawerStatus == false) {
      dispatch(toggleRightDrawer());
    }
  }

  const onOpenTestcases = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    dispatch(setFocusElement({ type: 'simulation_testcases', action: "list", id: selectedSimulation._id, name: "Testcases", description: selectedSimulation.description }));
    if (rightDrawerStatus == false) {
      dispatch(toggleRightDrawer());
    }

  }

  const onDeleteTransaction = () => {
    if (codeEditStatus) {
        dispatch(setIsDocumentClicked());
        console.log("Code edit status is true")
        return;
    }

    handleActionClose();
    toggleMenuRightdrawer(false);
    setOpenDeleteTransaction(true)
  }

  const onDeleteSimulation = () => {
    handleActionClose();
    toggleMenuRightdrawer(false);
    setOpenDeleteSimulation(true)
  }

  const onCloneTransaction = () => {
    if (codeEditStatus) {
        dispatch(setIsDocumentClicked());
        console.log("Code edit status is true")
        return;
    }


    handleActionClose();
    toggleMenuRightdrawer(false);
    setOpenCloneTransaction(true);
  }

  


  const handleDeploySelectorClose = (payload) => {
    
    const { disableIcon } = payload;
    setDeploySelectorPopUp(false);

    if (disableIcon === false) dispatch(setDeployLoader({ status: false }))
  }


  const onClusterletConfigCompletion = () => {
    dispatch(handleSnackBar({ open: true, message: 'View clusterlet configuration updated', severity: "success" }));
    handleCloseClusterletConfig();
  }

  const onDeleteTransactionCompletion = (type, action) => {
    handleCloseDeleteTransaction();
    setOpenDeleteTransaction(false);
    if (type !== undefined) {
      dispatch(handleSnackBar({ open: true, message: 'Transaction deleted succesfully', severity: "success" }));
    }
  }

  const onDeleteSimulationCompletion = () => {
    dispatch(handleSnackBar({ open: true, message: 'Simulation deleted succesfully', severity: "success" }));
    handleCloseDeleteSimulation();
  }

  const onCloneTransactionCompletion = () => {
    dispatch(handleSnackBar({ open: true, message: 'Transaction cloned successfully', severity: "success" }));
    handleCloseCloneTransaction();
  }

  const onRenameBlueprintCompletion = (title, description) => {
    handleCloseRenameBlueprint();
    selectedBlueprint.name = title;
    selectedBlueprint.description = description;
    setSelectedBlueprint(selectedBlueprint);
  }

  const handleBackDropToggle = () => {
    setIsBlueprintSwitching((prev) => !prev);
  };

  const exitTheBuilder = (force) => {
    if (codeEditStatus) {  // For alert to save when code is editing
      dispatch(setIsDocumentClicked());
      return;
    }
    if(aiAssistantLoading && !force){
      setShowExitAlert(true)
      return
    }
    setShowExitAlert(false);
    handleBackDropToggle();
    dispatch(invokePostService('removeLocks', {}, []));
    history.push(`/`);
    dispatch(resetBluePrint());
    dispatch(clearAll()).then(async res => {
      handleBackDropToggle();
    })
  };

  const handleManualTour = () => {
    if (codeEditStatus) {
      dispatch(setIsDocumentClicked());
      return;
    }

    if(currentUrl.includes('system-model')){
      dispatch(triggerTour({currentTour: 'systemModel', initStart: true}))
    }else if(currentUrl.includes('view')){
      dispatch(triggerTour({currentTour: 'views', initStart: true}))
    }else if(currentUrl.includes('assets')){
      dispatch(triggerTour({currentTour: 'assets', initStart: true}))
    }else if(currentUrl.includes('testsuite')){
      dispatch(triggerTour({currentTour: 'simulationTestcase', initStart: true}))
    }else if(currentUrl.includes('transaction')){
      dispatch(triggerTour({currentTour: 'transaction', initStart: true}))
    }else if(currentUrl.includes('platform-schema')){
      dispatch(triggerTour({currentTour: 'platformSchema', initStart: true}))
    }
    
  }

  const fetchValidations = async () => {
          setValidationsLoading(true);
          try {
            dispatch(invokeGetService('validateBlueprint', [])).then(response => {
              if (response.status) {
                if (response.data) {
                  const errors = response.data?.errors || [];
                  const warnings = response.data?.warnings || [];
                  let list = [...errors, ...warnings]
                  setValidationsList(list);
                } else {
                  console.log("--No validation data found--")
                }
                
              } else {
                throw new Error('Response not found')
              }
      
            }).catch(error => {
              console.error(`Fetching validations failed. ${error}`);
            })

          } catch (err) {
            console.error("Fetching validations failed.", err);
          } finally {
            setValidationsLoading(false);
          }
    };


  const handleAgentModal = () => {
    switch(currentScreen){
      case "view":
        dispatch(updateAiAssistant({aiAssistantOpen: true, isMinimized: false, step: "view", requestContext: {isCreate: false, entity: selectedView, entityType: 'view'}}))
        break;
      case 'transaction':
        dispatch(updateAiAssistant({aiAssistantOpen: true, isMinimized: false, step: "transaction", requestContext: {isCreate: false, entity: selectedTransaction, entityType: 'transaction'}}))
        break;
      case 'system-model':
        dispatch(updateAiAssistant({aiAssistantOpen: true, isMinimized: false, step: "system_model", requestContext: {entityType: 'system_model'}}))
        break;
      case 'testsuite':
        dispatch(updateAiAssistant({aiAssistantOpen: true, isMinimized: false, step: "simulation", requestContext: {isCreate: false, entity: selectedSimulation, entityType: 'simulation'}}))
        break;
      default:
        dispatch(updateAiAssistant({aiAssistantOpen: true, isMinimized: false, step: "system_model", requestContext: {entityType: 'system_model'}}))
        break;
    }
  }

  const handleSaveClose = () => setOpenSave(null);
  const handleBuildMenuclose = () => setOpenBuildMenu(null);
  const handleActionClose = () => setActionsAnchorEl(null);
  const handleCloseBackupRestore = () => setOpenBackupRestore(false);
  const handleBlueprintListClose = () => setBlueprintsAnchorEl(null);
  const handleCloseClusterletConfig = () => setOpenClusterletConfig(false);
  const handleCloseRenameBlueprint = () => setOpenRenameBlueprint((prev) => !prev);
  const handleCloseCloneTransaction = () => setOpenCloneTransaction(false);
  const handleCloseDeleteTransaction = () => setOpenDeleteTransaction(false);
  const handleCloseDeleteSimulation = () => setOpenDeleteSimulation(false);
  const handleCancelBlueprintValidation = () => {
    setBlueprintValidatorOpen(false);
    setDeployConfig(null);
    dispatch(setDeployLoader({ status: false }));
  }

  useEffect(() => {
    if(currentUrl.includes('system-model') || currentUrl.includes('view') || currentUrl.includes('assets') || currentUrl.includes('testsuite') || currentUrl.includes('transaction') | currentUrl.includes('platform-schema')){
      setTour(true)
    }else{
      setTour(false)
    }
  },[currentUrl])

  

  return (
    <div className={classes.root}>
      <AlertDialog 
          title="Confirm Exit" 
          content="This will stop ongoing AI generation. Are you sure you want to leave?" 
          proceedText="Proceed" 
          abortText="Cancel" 
          onProceed={() => exitTheBuilder(true)} 
          onClose={() => setShowExitAlert(false)} 
          open={showExitAlert} 
      />
      {/* <AIAssistanceModal open={true} /> */}
      <AppBar position="fixed" className={`${classes.AppBar} blueprint-topbar`}>
        <Toolbar className={classes.toolbar}>
          <img src={HyperbloxLogo} alt="Hyperblox logo" className={classes.logo} />
          <div className={classes.dividerContainer}>
            <Divider orientation="vertical" flexItem className={classes.divider} />
          </div>
          <div className={classes.blueprintsDiv}>
            <img src={`${process.env.PUBLIC_URL}/ide_icons/blueprint.svg`} alt='hyperblox blueprints' />
            <Typography variant="h6" className={classes.blueprints} onClick={() => exitTheBuilder()} >
              Blueprints
            </Typography>
          </div>
          <div className={classes.dividerContainer}>
            <Divider orientation="vertical" flexItem className={classes.divider} />
          </div>
          <BlueprintSelect 
            allBlueprints={allBlueprints} 
            onSelectBlueprint={onSelectBlueprint} 
            selectedBlueprint={selectedBlueprint}
          />
          {/* <Button id="blueprints-btn" onClick={handleBlueprintClick} aria-controls="blueprits-menu" className={classes.blueprintList} endIcon={<img src={`${process.env.PUBLIC_URL}/ide_icons/arrowDropdown.svg`} />} data-ui-tour-id='tb-blueprints-btn'>
            {selectedBlueprint?.name}
          </Button>
          <Menu
            id="blueprits-menu"
            anchorEl={blueprintsAnchorEl}
            keepMounted
            open={Boolean(blueprintsAnchorEl)}
            onClose={handleBlueprintListClose}
            className={classes.dropdownMenu}
            classes={{
              paper: classes.dropdownMenuPaper,
            }}
          >
            {sharedBlueprints.length > 0 && myBlueprints.length > 0 && <ListSubheader className={classes.actionsHeading} disableSticky={true}>My Blueprints</ListSubheader>}
            {myBlueprints.map(bp => {
              return (
                <MenuItem disabled={bp?._id == selectedBlueprint?._id ? true : false} className={classes.menuItem} onClick={e => onSelectBlueprint(e, bp)}>{bp.name}</MenuItem>
              )
            })}
            {sharedBlueprints.length > 0 &&
              <ListSubheader className={classes.actionsHeading} disableSticky={true}>Shared Blueprints</ListSubheader>
            }
            {sharedBlueprints.length > 0 &&
              sharedBlueprints.map(bp => {
                return (
                  <MenuItem disabled={bp?._id == selectedBlueprint?._id ? true : false} className={classes.menuItem} onClick={e => onSelectBlueprint(e, bp)}>{bp.name}</MenuItem>
                )
              })}
          </Menu> */}
          {
            (screen == 'df' && selectedTransaction !== null && selectedTransaction !== undefined) && <>
              <div className={classes.dividerContainer}>
                <Divider orientation="vertical" flexItem className={classes.divider} />
              </div>
              <div className={classes.titleRow}>
                <EditableTitle id={"transactionName"} title={selectedTransaction.name} entityId={selectedTransaction._id} titleStyle={{marginLeft: 0, padding: "4px 2px"}} endPoint={"updateTransactionInfo"} dataKey={"transaction"}/>
                <OwnershipStatusLabel entity={selectedTransaction} />
              </div>
            </>
          }

          {
            (screen == 'testsuite' && selectedSimulation !== null && selectedSimulation !== undefined) && <>
              <div className={classes.dividerContainer}>
                <Divider orientation="vertical" flexItem className={classes.divider} />
              </div>
              <div className={classes.titleRow}>
                <EditableTitle id={"testsuiteName"} title={selectedSimulation.name} entityId={selectedSimulation._id} titleStyle={{marginLeft: 0, padding: "4px 2px"}} endPoint={"updateSimulationTestsuite"} dataKey={"testsuite"}/>
                <OwnershipStatusLabel entity={selectedSimulation} />
              </div>
            </>
          }

          {normalScreen ? <>
            <div className={classes.undoRedoDiv}>
              <UndoRedo disabled={isBlueprintSwitching} />
            </div> 
            <div style={{ marginLeft: 'auto', display: 'flex' }}>

              <Tooltip title= {tooltipTitle}>  
                <button disabled={isAIAssistantActive} className={`${classes.promptBtn} ${isAIAssistantActive && classes.disableAgent}`} data-ui-tour-id="btn-ai-agent" onClick={handleAgentModal}>
                  <img src="/node_icons/ai.png" style={{width: '100%'}} alt="hyperblox agent"/>
                </button>
              </Tooltip>
              {
                showTour && 
                <Tooltip title='Show Tour'>
                  <button className={classes.promptBtn} style={{marginLeft: '0.5rem'}} onClick={handleManualTour}>
                    <img src="/node_icons/question.svg" style={{width: '100%'}} alt="hyperblox agent"/>
                  </button>
                  {/* <Icon onClick={handleManualTour} style={{height: '2rem', width: 'auto', display: 'flex',justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <ContactSupportIcon style={{fontSize: '2rem'}}/>
                  </Icon> */}
                </Tooltip>
              }
              {/* {
                (deployBatches && deployBatches.length) ?
                <Button disabled={isBlueprintSwitching} variant="outlined" id="open-app-view-btn" aria-controls="open-app-view-button" onClick={handleRedirectToAppview} className={classes.openNewTab} startIcon={<OpenInNewIcon/>} >Open App view</Button>
                :null
              } */}
              <Button disabled={isBlueprintSwitching} variant="outlined" id="actions-btn" aria-controls="actions-menu" onClick={handleActionsClick} className={classes.actionsBtn} endIcon={<img src={`${process.env.PUBLIC_URL}/ide_icons/arrowDropdown.svg`} />} data-ui-tour-id='tb-actions-btn'>Actions</Button>
              <Menu
                id="actions-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleActionClose}
                className={classes.dropdownMenu}
                classes={{
                  paper: classes.dropdownMenuPaper,
                  list: screen == "sm" || screen == "df" ? classes.dropdownMenuList : classes.dropdownMenuListWithPadding
                }}
              >
                <>
                  {screen == "sm" &&
                    <>
                      <ListSubheader className={classes.actionsHeading} disableSticky={true}>System Model</ListSubheader>
                      <MenuItem id="create-clusterlet" className={classes.menuItem} onClick={onCreateClusterlet}>Create Clusterlet</MenuItem>
                      <MenuItem id="create-delegate" className={classes.menuItem} onClick={onCreateDelegate}>Create Delegate</MenuItem>
                      <MenuItem id="create-digital-twin" className={classes.menuItem} onClick={onCreateDigitalTwin}>Create Digital Twin</MenuItem>
                      <MenuItem id="create-enterprise-app" className={classes.menuItem} onClick={onCreateEnterpriseApp}>Create Enterprise App</MenuItem>
                      <MenuItem id="create-infer-engine" className={classes.menuItem} onClick={onCreateInferEngine}>Create Infer Engine</MenuItem>
                      <MenuItem id="create-learn-engine" className={classes.menuItem} onClick={onCreateLearnEngine}>Create Learn Engine</MenuItem>
                      <MenuItem id="create-generate-engine" className={classes.menuItem} onClick={onCreateGenerateEngine}>Create Generate Engine</MenuItem>
                      <Divider />
                    </>
                  }
                  {(screen == "df" && selectedTransaction !== null && selectedTransaction !== undefined) &&
                    <>
                      <ListSubheader className={classes.actionsHeading} disableSticky={true}>Transaction</ListSubheader>
                      <MenuItem id="edit-transaction" className={classes.menuItem} onClick={onEditTransaction}>Edit Transaction</MenuItem>
                      <MenuItem id="clone-transaction" className={classes.menuItem} onClick={onCloneTransaction}>Clone Transaction</MenuItem>
                      <MenuItem id="delete-transaction" className={classes.menuItem} onClick={onDeleteTransaction}>Delete Transaction</MenuItem>
                      <Divider />
                    </>
                  }
                  {screen == "simulation" &&
                    <>
                      <MenuItem id="list_testcases" className={classes.menuItem} onClick={onOpenTestcases}>Testcases</MenuItem>
                      <MenuItem id="edit-simulation" className={classes.menuItem} onClick={onEditSimulation}>Edit Scenario</MenuItem>
                      <MenuItem id="delete-simulation" className={classes.menuItem} onClick={onDeleteSimulation}>Delete Simulation</MenuItem>
                    </>
                  }
                  <MenuItem id="event-types" className={classes.menuItem} onClick={onEventTYpes}>Event Types</MenuItem>
                  <MenuItem id="import-messages" className={classes.menuItem} onClick={onImportMessages}>Import Event Types</MenuItem>
                  <MenuItem id="select-clusterlet-dashboard" className={classes.menuItem} onClick={onSelectClusterletDashboard}>Choose dashboard clusterlets/profiles</MenuItem>
                </>


              </Menu>
              <>
                <Button variant="outlined" disabled={savingInProgress || isBlueprintSwitching ? true : false} id="save-btn" aria-controls="save-menu" onClick={handleSaveClick} className={classes.saveBtn} endIcon={<img src={`${process.env.PUBLIC_URL}/ide_icons/arrowDropdown.svg`} />} data-ui-tour-id='tb-save-btn'>Save</Button>
                <Menu
                  id="save-menu"
                  anchorEl={openSave}
                  keepMounted
                  open={Boolean(openSave)}
                  onClose={handleSaveClose}
                  className={classes.dropdownMenu}
                  classes={{
                    paper: classes.dropdownMenuPaper,
                  }}
                >
                  <MenuItem id="backup-restore" className={classes.menuItem} onClick={onBackupRestore}>Backup/Restore Blueprint</MenuItem>
                </Menu>

                {/* Build menu */}
                <Button variant="outlined" disabled={isBlueprintSwitching ? true : false} id="buildMenu-btn" aria-controls="build-menu" onClick={handleBuildMenuClick} className={classes.buildMenuBtn} endIcon={<img src={`${process.env.PUBLIC_URL}/ide_icons/arrowDropdown.svg`} />} data-ui-tour-id='tb-build-btn'>Build</Button>
                <Menu
                  id="build-menu"
                  anchorEl={openBuildMenu}
                  keepMounted
                  open={Boolean(openBuildMenu)}
                  onClose={handleBuildMenuclose}
                  className={classes.dropdownMenu}
                  classes={{
                    paper: classes.dropdownMenuPaper,
                  }}
                >
                  <MenuItem title="Build blueprint" id="build-btn" disabled={isBlueprintSwitching ? true : false} className={classes.menuItem} onClick={onBuildBlueprint} >Build</MenuItem>
                  <MenuItem title="Deploy blueprint to a Controller" id="deploy-btn" className={classes.menuItem} onClick={onDeployBlueprint} >Deploy</MenuItem>
                  <MenuItem title="Run the configured simulations" id="run-simulation" className={classes.menuItem} onClick={onRunSimulation}>Run Simulation</MenuItem>
                  <MenuItem title="View build history" id="build-history-btn" className={classes.menuItem} onClick={openBuildHistory} >Build History</MenuItem>
                  <MenuItem title="View deployment history" id="deployment-history-btn" className={classes.menuItem} onClick={openDeploymentHistory} >Deployment History</MenuItem>
                  <MenuItem title="View simulation history" id="view-simulation-history" className={classes.menuItem} onClick={() => onViewSimulationLogs(true)}>Simulation History</MenuItem>
                  <MenuItem title="Export blueprint compiled output" id="export-blueprint-files" className={classes.menuItem} onClick={onExportBlueprint}>Export Blueprint Files</MenuItem>
                  <MenuItem title="View last blueprint compiled output" id="view-build-files" className={classes.menuItem} onClick={onViewBuildFiles}>View Build Files</MenuItem>
                </Menu>
              </>
            </div>

          </>
            : mediumScreen ?
              <>
                <div className={classes.undoRedoDiv}>
                  {/* <UndoRedo /> */}
                </div>
                <div style={{ marginLeft: 'auto' }}>
                  {!rightMenuOpen &&
                    <IconButton id="menu-open-btn" style={{ flexGrow: 1 }} onClick={() => toggleMenuRightdrawer(true)}>
                      <MenuIcon />
                    </IconButton>
                  }
                  {rightMenuOpen &&
                    <IconButton id="menu-close-btn" style={{ flexGrow: 1 }} onClick={() => toggleMenuRightdrawer(false)}>
                      <CloseIcon />
                    </IconButton>
                  }
                </div>
              </>
              :
              <>
                <div style={{ marginLeft: 'auto' }}>
                  {!rightMenuOpen &&
                    <IconButton id="menu-open-btn" style={{ flexGrow: 1 }} onClick={() => toggleMenuRightdrawer(true)}>
                      <MenuIcon />
                    </IconButton>
                  }
                </div>
              </>
          }

        </Toolbar>
      </AppBar>

      {(rightMenuOpen && !normalScreen) &&
        <Drawer
          className={classes.menuDrawer}
          anchor="right"
          open={rightMenuOpen}
          variant="persistent"
          onClose={() => toggleMenuRightdrawer(false)}
          classes={{
            paper: classes.menuDrawerPaper,
          }}
        >
          <div style={{ marginLeft: 'auto' }}>
            {rightMenuOpen &&
              <IconButton id="menu-close-btn" style={{ flexGrow: 1 }} onClick={() => toggleMenuRightdrawer(false)}>
                <CloseIcon />
              </IconButton>
            }
          </div>
          <List className={classes.menuDrawerList}>
            {!mediumScreen &&
              <>
                <ListSubheader disableSticky={true} align="right">Undo & Redo</ListSubheader>
                {/* <UndoRedo view="mobile" disabled={isBlueprintSwitching} /> */}
              </>
            }
            <ListSubheader disableSticky={true} align="right">Actions</ListSubheader>
            {screen == 'sm' &&
              <>
                <ListItem id="create_clusterlet" className={classes.listItem} button onClick={onCreateClusterlet}>
                  <ListItemText primary="Create Clusterlet" />
                </ListItem>
                <ListItem id="create_delegate" className={classes.listItem} button onClick={onCreateDelegate}>
                  <ListItemText primary="Create Delegate" />
                </ListItem>
                <ListItem id="create_digital_twin" className={classes.listItem} button onClick={onCreateDigitalTwin}>
                  <ListItemText primary="Create Digital Twin" />
                </ListItem>
                <ListItem id="create_enterprise_app" className={classes.listItem} button onClick={onCreateEnterpriseApp}>
                  <ListItemText primary="Create Enterprise App" />
                </ListItem>
                <ListItem id="create_infer_engine" className={classes.listItem} button onClick={onCreateInferEngine}>
                  <ListItemText primary="Create Infer Engine" />
                </ListItem>
                <ListItem id="create_learn_engine" className={classes.listItem} button onClick={onCreateLearnEngine}>
                  <ListItemText primary="Create Learn Engine" />
                </ListItem>
                <ListItem id="create_generate_engine" className={classes.listItem} button onClick={onCreateGenerateEngine}>
                  <ListItemText primary="Create Generate Engine" />
                </ListItem>
                <Divider />
              </>
            }
            {(screen == 'df' && selectedTransaction !== null && selectedTransaction !== undefined) &&
              <>
                <ListItem id="add_event" className={classes.listItem} button onClick={onAddEvent}>
                  <ListItemText primary="Add Event" />
                </ListItem>
                <ListItem id="child_transaction" className={classes.listItem} button onClick={onChildTransaction}>
                  <ListItemText primary="Create Child Transaction" />
                </ListItem>
                <ListItem id="clone_transaction" className={classes.listItem} button onClick={onCloneTransaction}>
                  <ListItemText primary="Clone Transaction" />
                </ListItem>
                <ListItem id="edit_transaction" className={classes.listItem} button onClick={onEditTransaction}>
                  <ListItemText primary="Edit Transaction" />
                </ListItem>
                <ListItem id="import_transaction" className={classes.listItem} button onClick={onImportTransaction}>
                  <ListItemText primary="Invoke Transaction" />
                </ListItem>
                <ListItem id="delete_transaction" className={classes.listItem} button onClick={onDeleteTransaction}>
                  <ListItemText primary="Delete Transaction" />
                </ListItem>
                <Divider />
              </>
            }
            <ListItem className={classes.listItem} id="event_types" button onClick={onEventTYpes}>
              <ListItemText primary="Event Types" />
            </ListItem>
            <ListItem className={classes.listItem} id="import_messages" button onClick={onImportMessages}>
              <ListItemText primary="Import Event Types" />
            </ListItem>
            <ListItem className={classes.listItem} id="select_clusterlet_dashboard" button onClick={onSelectClusterletDashboard}>
              <ListItemText primary="Choose dashboard clusterlets/profiles" />
            </ListItem>
            <ListSubheader disableSticky={true} align="right">Save</ListSubheader>
            <ListItem className={classes.listItem} id="backup_restore" button onClick={onBackupRestore}>
              <ListItemText primary="Backup/Restore Blueprint" />
            </ListItem>
            <ListSubheader disableSticky={true} align="right">Build & Deploy</ListSubheader>
            <ListItem className={classes.listItem} button disabled={buildLoading} onClick={onBuildBlueprint}>
              <ListItemText primary="Build" />
            </ListItem>
            <ListItem className={classes.listItem} button onClick={openBuildHistory}>
              <ListItemText primary="Build History" />
            </ListItem>
            <ListItem className={classes.listItem} button onClick={openDeploymentHistory}>
              <ListItemText primary="Deployment History" />
            </ListItem>
            <ListItem className={classes.listItem} id="export_blueprint_files" button onClick={onExportBlueprint}>
              <ListItemText primary="Export Blueprin Files" />
            </ListItem>
            <ListItem className={classes.listItem} button onClick={onDeployBlueprint}>
              <ListItemText primary="Deploy" />
            </ListItem>
            <ListItem className={classes.listItem} id="view_build_files" button onClick={onViewBuildFiles}>
              <ListItemText primary="View Build Files" />
            </ListItem>
            <ListItem className={classes.listItem} id="view_simulation_files" button onClick={onViewSimulationLogs}>
              <ListItemText primary="View Simulation Logs" />
            </ListItem>
          </List>

        </Drawer>
      }
      {validationError.length > 0 && <ErrorPresenter errors={validationError} closeCallback={() => { setValidationError([]); dispatch(setBuildLoader({ status: false })) }} cancelCallback={() => { setValidationError([]); dispatch(setBuildLoader({ status: false })) }} messageTemplate={`The '[feature]' attribute is missing for the routing rule [item]`} />}
      {deploySelectorPopUp && 
        <DeploySelector 
          onClose={handleDeploySelectorClose} 
          onDeployBlueprint={deployBlueprint} 
          setBlueprintValidatorOpen={setBlueprintValidatorOpen} 
          setDeployConfig={setDeployConfig} 
          fetchValidations={fetchValidations}  
          validationsList={validationsList} 
          setValidationsList={setValidationsList} 
          setDeploymentData={setDeploymentData} 
        />
      }
      {/* {openTemplates && <CreateTemplateDialog onClose={handleCloseTemplates} onCompletion={() => { }} />} */}
      {openBackupRestore && <RestoreBlueprintAlert onClose={handleCloseBackupRestore} onCompletion={() => { }} />}
      {/* {openClusterletConfig && <ClusterletsConfiguration onClose={handleCloseClusterletConfig} onCompletion={onClusterletConfigCompletion} />} */}
      {openClusterletConfig && <ClusterletViewSelectorForDashboard onClose={handleCloseClusterletConfig} />}
      {openCloneTransaction && <CloneTransaction open={openCloneTransaction} onClose={handleCloseCloneTransaction} onCompletion={onCloneTransactionCompletion} selectedTransaction={selectedTransaction} />}
      {openDeleteTransaction && <DeleteTransactionAlert onCompletion={onDeleteTransactionCompletion} element={{ id: selectedTransaction?._id, name: selectedTransaction?.name, type: selectedTransaction?.type }} onClose={handleCloseDeleteTransaction} />}
      {openDeleteSimulation && <DeleteSimulationAlert onCompletion={onDeleteSimulationCompletion} element={{ id: selectedSimulation?._id, name: selectedSimulation?.name }} onClose={handleCloseDeleteSimulation} />}
      {openBuildFiles && <BuildAlert onClose={() => setOpenBuildFiles(false)} logType='build'/>}

      {/* {openBuildFiles && <BuildFilesAlert onClose={() => setOpenBuildFiles(false)} />} */}
      {openRunSimulationDialog && <RunSimulationDialog onClose={() => setOpenRunSimulationDialog(false)} setOpenSimulationLogs={(status) => dispatch(toggleSimulationRun(status ? "live" : false))} />}
      {/* {openSimulationLogs && <SimulationLogsAlert onClose={() => setOpenSimulationLogs(false)} />} */}
      {openBuildLogs && <BuildAlert onClose={() => setOpenBuildLogs(false)} logType='build' />}
      {/* {openBuildLogs && <BuildDeployLogAlert onClose={() => setOpenBuildLogs(false)} logType='build' />} */}
      {/* {openDeployLogs && <BuildDeployLogAlert onClose={() => setOpenDeployLogs(false)} logType='deploy' />} */}
      {openDeployLogs && <BuildAlert onClose={() => setOpenDeployLogs(false)} logType='deploy' />}
      {openExportBlueprintAlert && <ExportBlueprintFilesAlert onClose={() => setOpenExportBlueprintAlert(false)} setOpenExportBlueprintAlert={setOpenExportBlueprintAlert} />}

      {openRenameBlueprint && <CustomizedDialogs
        open={openRenameBlueprint}
        title="Edit Blueprint"
        handleClose={handleCloseRenameBlueprint}
      >
        <RenameBlueprintForm onClose={handleCloseRenameBlueprint} onCompletion={onRenameBlueprintCompletion} />
      </CustomizedDialogs>
      }

      {/* {blueprintValidatorOpen && <BlueprintValidator onCancel={handleCancelBlueprintValidation} onContinue={() => { setBlueprintValidatorOpen(false); deployBlueprint() }} />} */}
      {/* {blueprintValidatorOpen && 
      <BlueprintValidationsList 
        validations={validationsList} 
        open={blueprintValidatorOpen} 
        onClose={() => setBlueprintValidatorOpen(false)} 
        loading={validationLoading}
        setLoading={setValidationsLoading}
        handleRefresh={fetchValidations}
        onDeployment={deployBlueprint}
        deploymentData={deploymentData}
      />} */}
      


      {isBlueprintSwitching === true && <Backdrop
        className={classes.backdrop}
        open={isBlueprintSwitching}
      >
        <CircularProgress size={30} color="inherit" />
      </Backdrop>}
    </div>
  );
}

export default withRouter(BlueprintTopBar);